import React, { useEffect, useState } from "react";
import { Row, Skeleton, Col, Button, message } from "antd";
import { useParams, Prompt } from "react-router-dom";
import { patchAdviseeProfileAttachment } from "apis/advisee";
import EditableTable from "../../../../../components/EditableTable/EditableTable";
import { isArray } from "util";
import UploadDragger from "components/Upload/Upload.Dragger";
import { SaveOutlined, EyeOutlined } from "@ant-design/icons";
import { randomNumberGenerator } from "utils/general";
import Locale from "react-intl-universal";

const EditableType = {
  number: "number",
  text: "text",
  selector: "selector",
  date: "date",
};

const UserAttachment = (props) => {
  const { id: adviseeId } = useParams();
  const [attachment, setAttachment] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [saveReminder, setSaveReminder] = useState(false);
  const personalDetails = props.personalInfo;

  // useEffect(() => {
  //   setTimeout(() => {
  //     setDataSource([
  //       {
  //         key: 9521969988,
  //         name: "Screenshot 2023-08-15 at 11.40.49 PM.png",
  //         remarks: "",
  //         title: "",
  //         uid: "rc-upload-1692287053541-2",
  //         url:
  //           "https://s3.ap-southeast-1.amazonaws.com/finport-upload-sls-prd-document-bucket/meb8llfc0phu_Screenshot%202023-08-15%20at%2011.40.49%20PM.png",
  //         _id: "",
  //       },
  //       {
  //         key: 95219699128,
  //         name: "Screenshot 2023-08-15 at 11.40.49 PM.png",
  //         remarks: "",
  //         title: "",
  //         uid: "rc-upload-1692287053541-2",
  //         url:
  //           "https://s3.ap-southeast-1.amazonaws.com/finport-upload-sls-prd-document-bucket/meb8llfc0phu_Screenshot%202023-08-15%20at%2011.40.49%20PM.png",
  //         _id: "",
  //       },
  //     ]);
  //     console.log("set Valuye");
  //   }, 2500);
  // }, []);

  useEffect(() => {
    if (
      personalDetails.profileAttachment &&
      personalDetails.profileAttachment.length > 0
    ) {
      setTimeout(() => {
        setDataSource(personalDetails.profileAttachment);
      }, 100);
      setTimeout(() => {
        setSaveReminder(false);
      }, 300);
    }
  }, [personalDetails]);

  useEffect(() => {
    const triggerReminder = (ev) => {
      if (saveReminder) {
        ev.preventDefault();
        return (ev.returnValue = "Are you sure you want to close?");
      }
    };

    if (saveReminder) {
      window.addEventListener("beforeunload", triggerReminder);
      window.addEventListener("unload", triggerReminder);
    } else {
      window.removeEventListener("beforeunload", triggerReminder);
      window.removeEventListener("unload", triggerReminder);
    }

    return () => {
      window.removeEventListener("beforeunload", triggerReminder);
      window.removeEventListener("unload", triggerReminder);
    };
  }, [saveReminder]);

  useEffect(() => {
    if (attachment && attachment.length > 0) {
      return;
    }
    setAttachment(personalDetails.attachment);
  }, [personalDetails.attachment]);

  useEffect(() => {
    if (
      isArray(props.data) === true &&
      props.data.length > 0
      // &&
      // dataSource.length === 0
    ) {
      setDataSource(props.data);
    }
  }, [props.data]);

  const handleAdd = (file) => {
    if (file && file.length === 0) {
      return;
    }

    var newData = {
      key: randomNumberGenerator(),
      title: "",
      remarks: "",
      _id: "",
      name: "",
      uid: "",
      url: "",
      ...file[0],
    };

    const output = [...dataSource, newData];
    setDataSource(output);
    setSaveReminder(true);
  };

  const handleSave = async () => {
    setSaveReminder(false);

    var buffer = dataSource.map((x) => ({
      name: x.name,
      uid: x.uid,
      url: x.url,
      title: x.title,
      remarks: x.remarks,
    }));
    const res = await patchAdviseeProfileAttachment(adviseeId, buffer);
    message.success(Locale.get("profileAttachment.saveSuccess"));
  };

  const uploadComponent = (
    <UploadDragger
      acceptTypes={["image/*", "application/pdf"]}
      isDisplayCard={false}
      onChange={(e) => {
        handleAdd(e);
      }}
      onFileUploadChange={(e) => {
        if (e) {
          message.loading(Locale.get("profileAttachment.uploadingFile"));
        }
      }}
      fileSizeLimitInMb={10}
      isMultiple={true}
      value={[]}
      style={{ marginTop: 16 }}
    />
  );

  const renderFileType = (filename) => {
    let formatIndex = String(filename).toLocaleLowerCase().lastIndexOf(".");
    let type = String(filename)
      .toLowerCase()
      .substring(formatIndex + 1, filename.length);

    switch (type) {
      case "jpeg":
      case "png":
      case "jpg":
      case "ico":
        return String("IMAGE/" + type.toUpperCase());

      case "pdf":
        return String("APPICATION/" + type.toUpperCase());
      default:
        return "-";
    }
  };

  const dataColumns = [
    {
      title: Locale.get("profileAttachment.dataColumn_a"),
      dataIndex: "title",
      key: "title",
      width: "25%",
      editable: true,
      editableType: EditableType.text,
      render: (value, record) => {
        return (
          <div
            style={{
              padding: 8,
              border: "1px solid #e0e0e0",
              cursor: "pointer",
              borderRadius: 8,
              width: "auto",
            }}
          >
            <Row>
              <Col>
                <span>{value ? value : "-"}</span>
              </Col>
            </Row>
          </div>
        );
      },
    },
    {
      title: Locale.get("profileAttachment.dataColumn_b"),
      dataIndex: "remarks",
      key: "remarks",
      width: "25%",
      editable: true,
      editableType: EditableType.text,
      render: (value, record) => {
        return (
          <div
            style={{
              padding: 8,
              border: "1px solid #e0e0e0",
              cursor: "pointer",
              borderRadius: 8,
              width: "auto",
            }}
          >
            <span>{value ? value : "-"}</span>
          </div>
        );
      },
    },
    {
      title: Locale.get("profileAttachment.dataColumn_c"),
      width: "10%",
      render: (record) => renderFileType(record.name),
    },
    {
      title: Locale.get("profileAttachment.dataColumn_d"),
      width: "20%",
      fixPaymentCategory: props.category,
      render: (value, record, index) => {
        return (
          <Row justify="end">
            <Button
              type="link"
              href={record.url}
              target="_blank"
              disabled={props.loading}
            >
              <EyeOutlined /> {Locale.get("profileAttachment.view")}
            </Button>
          </Row>
        );
      },
    },
  ];

  return (
    <div>
      <Row>
        <Col span={24}>
          <Row
            justify="space-between"
            style={{
              marginBottom: 16,
            }}
          >
            <Col>
              <span
                style={{
                  fontSize: 32,
                  fontWeight: 800,
                  color: "#000000",
                }}
              >
                {Locale.get("profileAttachment.pageTitle")}
              </span>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={handleSave}
              >
                {Locale.get("profileAttachment.saveButton")}
              </Button>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <EditableTable
            columns={dataColumns}
            initialValue={dataSource}
            defaultValue={dataSource}
            value={dataSource}
            onChange={(e) => {
              if (JSON.stringify(e) !== JSON.stringify(dataSource)) {
                setSaveReminder(true);
                setDataSource(e);
              }
            }}
            hideAddRow={true}
          />
        </Col>
        <Col span={24}>{uploadComponent}</Col>
        <Prompt
          when={saveReminder}
          message="Are you sure you want to leave before save?"
        />
      </Row>
    </div>
  );
};

export default UserAttachment;
